export const tableHeaders = [
  {
    id: 1,
    label: 'File',
    intlKey: 'table.file'
  },
  {
    id: 2,
    label: 'Title',
    intlKey: 'table.title'
  },
  {
    id: 4,
    label: 'Uploaded by',
    intlKey: 'table.uploaded_by'
  },
  {
    id: 5,
    label: 'Email',
    intlKey: 'table.date'
  },
  {
    id: 6,
    label: 'Category',
    intlKey: 'table.category'
  },
  {
    id: 7,
    label: 'Section',
    intlKey: 'table.section'
  },
  {
    id: 8,
    label: 'Parental Consent',
    intlKey: 'table.parental_consent'
  },
  {
    id: 9,
    label: 'Assessor report',
    intlKey: 'table.assessor_report'
  },
  {
    id: 10,
    label: 'Observation file',
    intlKey: 'table.observation_file'
  },
  {
    id: 11,
    label: 'Action',
    intlKey: 'table.action'
  }
]
